<template>

  <div class="crc-car-component-container mt-md-5 mb-5">
    <router-view></router-view>
    <div class="crc-favbar">
      <button class="w-100 m-0 h5 title p-4 d-flex align-items-center justify-content-between honda-favbar-toggle" id="togglebtn" @click="toggleFavoriteBar()"><span> {{ favorites.length }}<svg width="32px" height="30px" viewBox="0 0 32 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="svg" transform="translate(0.000217, -0.000052)" fill="#FF0000" fill-rule="nonzero"><path d="M16,2.62817487 C24.876241,-6.49607291 47.0688437,9.47036067 16,30.0009182 C-15.0688437,9.47236072 7.12375896,-6.49607291 16,2.62817487 Z" id="Path"></path></g></g></svg></span></button>
    </div>

    <div class="car-favorites-container" style="z-index: 9999999; min-height: 120px; float:right; top: 10em; position: fixed; right:0; overflow-y: auto; max-height: calc(100vh - 10em); margin-right: 55px;">
      <div class="collapse collapse-horizontal" id="carFavorites">
        <div class="card card-body" style="width: 400px;">
          <p class="nofavorites">Er zijn nog geen favorieten toegevoegd.</p>
          <div v-for="fav in favorites" class="w-100 mt-4" v-bind:key="fav.extradata.autoid">
            <a :href="'https://'+domain()+'/aanbod/'+getslug(fav)"  class="card d-flex flex-column text-decoration-none mt-2">
              <div class="card-img-top crc-img-container">
                <img :src="fav.photos[0].thumb" @click.prevent="viewCar(fav)">
              </div>
              <div class="card-body">
                <h3 class="card-title">{{ fav.title }} <i @click.prevent="togglefavorite(fav)"><svg class="me-2" width="20px" height="20px"><use xlink:href="#Icon--heart-filled"></use></svg></i></h3>
                <p class="card-text" @click.prevent="viewCar(fav)">{{ fav.mappeddata.type }}</p>
                <div class="card-usps d-flex flex-wrap" @click.prevent="viewCar(fav);">
                  <span>{{  translateDict[fav.mappeddata.transmission] ?? fav.mappeddata.transmission }}</span>
                  <span>{{ fav.mappeddata.year }}</span>
                  <span>{{ fav.mappeddata.milage }} km</span>
                </div>
              </div>
              <div class="card-footer">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center"><span>Kenteken:</span> <span>{{ fav.mappeddata.plate }}</span></li>
                  <li class="list-group-item d-flex flex-wrap justify-content-between align-items-center"><span>Prijs:</span> <span>{{ formatPrice(fav.mappeddata.price) }}</span></li>
                </ul>
                <a :href="'https://'+domain()+'/aanbod/'+getslug(fav)" @click.prevent="viewCar(fav);" class="card-link btn mt-3">Bekijk auto</a>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <svg display="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <symbol id="Icon--heart">
          <title>heart</title>
          <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
        </symbol>
        <symbol id="Icon--heart-filled">
          <title>heart-filled</title>
          <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
        </symbol>
        <symbol id="Icon--checkmark" viewBox="0 0 512 512">
          <title>checkmark</title>
          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
        </symbol>

        <symbol id="Icon--chevron-down" viewBox="0 0 448 512">
          <title>chevron-down</title>
          <path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
        </symbol>

        <symbol id="Icon--times" viewBox="0 0 448 512">
          <title>times</title>
          <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
        </symbol>
      </defs>
    </svg>
  </div>
</template>

<script>
import 'jquery'
import 'popper.js'
import {useCarStore} from "@/stores/car";
import 'bootstrap';

export default {
  props:['filters'],
  name: 'App',
  data() {
    return {
      fromArchive:1,
      translateDict: {
        "j":"Nieuw",
        "n":"Occasion",
        "B":"Benzine",
        "D":"Diesel",
        "B,E":"Benzine & Elektrisch",
        "D,E":"Diesel & Elektrisch",
        "E":"Elektrisch",
        "H":"Handgeschakeld",
        "A":"Automaat",
        "C":"Automaat"
      },
      pagetitle:'',
      overviewPagetitle:'',
      favorites:[],
      favoritesOpened: false,
      originalog:{
        'title':null,
        'image':null,
        'description':null
      }
    }
  },
  mounted() {
    this.pagetitle = document.title.split('-')[document.title.split('-').length-1];
    this.getFavorites()
    this.emitter.on("updateFavorites", () => {
      this.getFavorites()
    })
    this.emitter.on("restoreMeta", () => {
      this.restoremeta()
    })

    // var jQuery = window.jq;
    window.jq('.honda-favbar-toggle').click(function() {
      window.jq('#carFavorites').slideToggle();
    });

    window.jq(document).on('click', function (e) {
      if (window.jq(e.target).closest(".car-favorites-container").length === 0 && window.jq(e.target).closest(".crc-favbar").length === 0 && window.jq("body").hasClass("favopened")) {
        window.jq("#togglebtn").click();
      }
    });

    const ogdesc = document.querySelector('meta[property="og:description"]');
    if (ogdesc !== null && this.originalog.description === null) {
      this.originalog.description =  ogdesc.content;
    }
    const ogimage = document.querySelector('meta[property="og:image"]');
    if (ogimage !== null && this.originalog.image === null) {
      this.originalog.image =  ogimage.content;
    }

    const ogtitle = document.querySelector('meta[property="og:title"]');
    if (ogtitle !== null && this.originalog.title === null) {
      this.originalog.title =  ogtitle.content;
    }


  },
  methods: {
    domain() {
      return window.location.host;
    },
    getslug(car) {
      return window.getslug(car);
    },
    restoremeta() {
      const ogtitle = document.querySelector('meta[property="og:title"]');
      if (ogtitle !== null && this.originalog.title !== null) {
        ogtitle.content = this.originalog.title;
      }
      const ogdesc = document.querySelector('meta[property="og:description"]');
      if (ogdesc !== null && this.originalog.description !== null) {
        ogdesc.content = this.originalog.description;
      }
      const ogimage = document.querySelector('meta[property="og:image"]');
      if (ogimage !== null &&  this.originalog.image !== null) {
        ogimage.content = this.originalog.image;
      }

    },
    formatPrice(price) {
      let euroformatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      });
      return euroformatter.format(price)
    },
    viewCar(car) {
      let type = car.mappeddata.type.replace(/[\W_]+/g,"-")
      let slug = car.mappeddata.slug.replace(/\D/g,"")
      this.$router.push({ name: 'DetailByModel', params: {model: window.slugify(car.mappeddata.brand) + '-' + window.slugify(car.mappeddata.model) + '-' + window.slugify(type+ '-')  + window.slugify(slug) } })
    },

    togglefavorite(car)
    {
      useCarStore().toggleFavorite(car.mappeddata.carid)
      this.getFavorites()
      if(this.favoritesOpened === true && this.favorites.length === 1)
      {
        this.favoritesOpened = false;
        window.jq('#carFavorites').slideToggle();
      }

      this.emitter.emit("updateFavorites", () => {
        this.getFavorites()
      })
    },
    toggleFavoriteBar() {
      if (!this.favoritesOpened) {
        window.jq('body').addClass('favopened');
      } else {
        window.jq('body').removeClass('favopened');
      }
      return this.favoritesOpened = !this.favoritesOpened;
    },
    async getFavorites()
    {
      await useCarStore().fetchCars();
      this.favorites = useCarStore().getFavorites();
      if(this.favorites.length === 0) {
          window.jq('.nofavorites').show();
        } else {
          window.jq('.nofavorites').hide();
        }
    }
  }
}

</script>

